import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import './Avisos.css';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import omnivore from '@mapbox/leaflet-omnivore';
import { limitsComarquesAmbMar } from '../../utils/urls';
import { COLORS_AVISOS as colors } from '../../utils/globals';
const FIRST_ID_SEA_LAYER = 88;
const DEFAULT_ZOOM = 6.6;

export class Avisos extends PureComponent {
    static propTypes = {
        currentDay: PropTypes.number,
        meterorsNav: PropTypes.object,
        data: PropTypes.object,
    };

    render() {
        const { preview } = this.props;
        return (
            <div
                className="Avisos mc-leaflet-map"
                id="map-avisos"
                style={{
                    height: !preview ? 'calc(100vh - 275px)' : null,
                    width: !preview ? '100%' : null,
                }}
            />
        );
    }

    componentDidMount() {
        this.map = L.map('map-avisos', {
            center: [41.7, 1.8],
            zoomSnap: 0.1,
            zoom: 6.6,
            minZoom: 6.6,
            maxZoom: 10,
            zoomControl: false,
            dragging: false,
            touchZoom: false,
            scrollWheelZoom: false,
            doubleClickZoom: false,
            attributionControl: false,
        });

        this.comarquesTopojson = this.topojsonLayerGenerator().addTo(this.map);

        window.addEventListener('resize', () => {
            const zoom = this.calculateZoom();
            this.map.setZoom(zoom);
        });
    }

    componentDidUpdate(prevProps) {
        if (this.props.data !== prevProps.data) {
            this.comarquesTopojson.eachLayer(layer => {
                layer.setStyle(
                    this.returnTileStyles(layer.feature.properties.IDComarca)
                );
            });
        }

        const zoom = this.calculateZoom();
        this.map.setZoom(zoom);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handler);
    }

    topojsonLayerGenerator() {
        const layerStyles = L.geoJson(null, {
            style: () => {
                return {
                    opacity: 1,
                    fillOpacity: 1,
                    weight: 1,
                    stroke: true,
                    color: colors.borderComarques,
                };
            },
        });

        // can't use arrow functions with omnivore ...
        const component = this;

        return omnivore
            .topojson(limitsComarquesAmbMar, null, layerStyles)
            .on('ready', function() {
                this.eachLayer(layer => {
                    const IDComarca = layer.feature.properties.IDComarca;
                    // We want sea layers to be transparent
                    if (IDComarca >= FIRST_ID_SEA_LAYER) {
                        layer.setStyle({
                            color: colors.borderSeaLayerSensePerill,
                        });
                    }
                    layer.setStyle(component.returnTileStyles(IDComarca));
                });
            });
    }

    returnTileStyles = IDComarca => {
        let styles =
            IDComarca < FIRST_ID_SEA_LAYER
                ? { fillColor: colors.sensePerill }
                : {
                      fillColor: colors.seaLayerSensePerill,
                      color: colors.borderSeaLayerSensePerill,
                  };

        const perill = this.props.data[IDComarca];
        if (perill) {
            styles.fillColor = this.getColorPerill(perill);
            if (IDComarca >= FIRST_ID_SEA_LAYER) {
                styles.color = this.props.meteorsNav[3]
                    ? colors.borderComarques
                    : colors.borderSeaLayerSensePerill;
                styles.fillColor = this.props.meteorsNav[3]
                    ? this.getColorPerill(perill)
                    : colors.seaLayerSensePerill;
            }
        }

        return styles;
    };

    getColorPerill(perill) {
        switch (perill) {
            case 1:
            case 2:
                return colors.perillModerat;
            case 3:
            case 4:
                return colors.perillAlt;
            case 5:
            case 6:
                return colors.perillMoltAlt;
            default:
                return colors.sensePerill;
        }
    }

    calculateZoom = () => {
        const w = window.innerWidth;
        const h = window.innerHeight;

        if ((w === 297 && h === 525) || this.props.preview) return DEFAULT_ZOOM;
        if (w > 650 && h > 880) return 8;
        if (w > 475 && h > 700) return 7.5;
        if (w > 375 && h > 600) return 7;

        return DEFAULT_ZOOM;
    };
}



// WEBPACK FOOTER //
// ./src/partials/Avisos/Avisos.js